/**
 * Musical constants used throughout ChordBaker.
 * This module provides canonical definitions for natural notes, modifiers, and other music theory constants.
 */
/**
 * All 7 natural notes (no accidentals).
 * Used for root note and bass note selection in the UI.
 *
 * @example
 * ```typescript
 * import { NATURAL_NOTES } from '@chordbaker/music-theory';
 *
 * // Use in note selector
 * const noteOptions = NATURAL_NOTES.map(note => ({ value: note, display: note }));
 * ```
 */
export const NATURAL_NOTES = ['C', 'D', 'E', 'F', 'G', 'A', 'B'];
/**
 * Modifier types for note selection.
 * Used in the chord editor UI for selecting accidentals.
 *
 * - natural: No accidental (display: '-')
 * - flat: Flat accidental (display: 'b', symbol: '♭')
 * - sharp: Sharp accidental (display: '#', symbol: '♯')
 *
 * @example
 * ```typescript
 * import { MODIFIERS } from '@chordbaker/music-theory';
 *
 * // Use in modifier selector
 * const modifierOptions = MODIFIERS.map(m => ({ value: m.type, display: m.display }));
 * ```
 */
export const MODIFIERS = [
    { type: 'natural', display: '-' },
    { type: 'flat', display: 'b' },
    { type: 'sharp', display: '#' },
];
